import { render } from "./Form2.vue?vue&type=template&id=4b38e8a4&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"

import "./Form2.vue?vue&type=style&index=0&id=4b38e8a4&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b38e8a4"]])

export default __exports__